module.exports = __webpack_public_path__ + "static/img/6.d479e3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/6.jpg
// module id = Ftv8
// module chunks = 21